<template>
  <v-row>
    <v-col class="mt-8 mb-">
      <v-row class="align-center">
        <v-icon
          class="mx-2"
          color="var(--color-text)"
        >
          mdi-clock-time-eight-outline
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ voyageDurationData.toFixed(2) }} days
        </h1>
      </v-row>
      <v-row class="align-center mt-8">
        <v-icon
          class="mx-2"
          color="var(--color-text)"
        >
          mdi-barrel
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ consumptionData.toFixed(2) }} mt
        </h1>
      </v-row>
    </v-col>
    <v-col class="mt-8 mb-3">
      <v-row class="align-center">
        <v-icon
          class="mx-2"
          color="var(--color-text)"
        >
          mdi-molecule-co2
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ emissionsData.toFixed(2) }} mt
        </h1>
      </v-row>
      <v-row class="align-center mt-8">
        <v-icon
          class="mx-2"
          color="var(--color-text)"
        >
          mdi-map-marker-distance
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ distanceData.toFixed(2) }} km
        </h1>
      </v-row>
    </v-col>
    <v-col
      v-if="showAllSavings"
      class="mt-8 mb-3"
    >
      <v-row
        v-if="showTimeSavings"
        class="align-center"
      >
        <v-icon
          class="mx-2"
          :color="totalTimeSavingsColor"
        >
          {{
            timeSavingsIcon
          }}
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ timeSavings.toFixed(2) }} %
        </h1>
      </v-row>
      <v-row
        v-if="showFuelSavings"
        class="align-center mt-8"
      >
        <v-icon :color="totalFuelSavingsColor">
          {{
            totalFuelSavingsIcon
          }}
        </v-icon>
        <v-icon
          class="ml-n2"
          :color="totalFuelSavingsColor"
        >
          mdi-barrel
        </v-icon>
        <h1 class="expansion-panel-header">
          {{ totalFuelSavings.toFixed(2) }} %
        </h1>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SolutionDataPanelContent",
  props: {
    voyageDurationData:{
      type: Number,
      default: 0,
    } ,
    consumptionData:{
      type: Number,
      default: 0,
    } ,
    emissionsData:{
      type: Number,
      default: 0,
    } ,
    distanceData:{
      type: Number,
      default: 0,
    } ,
    totalFuelSavings:{
      type: Number,
      default: 0,
    } ,
    timeSavings:{
      type: Number,
      default: 0,
    } ,
  },
  computed: {
    timeSavingsIcon() {
      return this.timeSavings > 0
        ? "mdi-sort-clock-ascending"
        : "mdi-sort-clock-descending";
    },
    totalFuelSavingsIcon() {
      return this.totalFuelSavings > 0 ? "mdi-arrow-down" : "mdi-arrow-up";
    },
    totalFuelSavingsColor() {
      return this.getSavingsColor(this.totalFuelSavings);
    },
    totalTimeSavingsColor() {
      return this.getSavingsColor(this.timeSavings);
    },
    showTimeSavings() {
      return this.showSaving(this.timeSavings);
    },
    showFuelSavings() {
      return this.showSaving(this.totalFuelSavings);
    },
    showAllSavings() {
      return this.showTimeSavings && this.showFuelSavings;
    },
  },
  methods: {
    getSavingsColor(saving) {
      return saving > 0 ? "green" : "red";
    },
    showSaving(saving) {
      return saving !== 0 && saving !== "undefined";
    },
  },
};
</script>

<style scoped>
.expansion-panel-header {
  font-size: 12px;
  color: var(--color-text);
  font-weight: 500;
}
</style>
